// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import moment from 'moment';

import Card from '../../../ui/Card';
import Button from '../../../ui/Button';
import IconButton from '../../../ui/IconButton';
import Spinner from '../../../ui/Spinner';
import Table, {
  Th, Td, Tr, TableToolbar,
} from '../../../ui/Table';
import {
  UploadIcon, EyeIcon, MailIcon, EditIcon, TrashIcon,
  ChevronRightIcon, ChevronDownIcon,
} from '../../../ui/icons';

import TemplateDropdown from './TemplateRow/Dropdown';
import Modals from './Modals';

class Templates extends Component {
  state = {
    activeName: '',
    targetName: '',
    modalOpen: false,
    modalType: null,
    emailDomainName: '',
  }

  componentDidUpdate() {
    const { activeEmailDomainName } = this.props.store.emailManagement;
    if (this.state.emailDomainName !== activeEmailDomainName) {
      this.setState({ emailDomainName: activeEmailDomainName, activeName: '' });
    }
  }

  rowClick = (name, template) => {
    const newName = this.state.activeName === name ? '' : name;
    this.setState({ activeName: newName });
    if (newName && !template.template) {
      this.props.store.emailManagement.getTemplate(name);
    }
  }

  preview = async (template) => {
    let html = template.template;
    if (!html) {
      const t = await this.props.store.emailManagement.getTemplate(template.name);
      html = t.template;
    }
    const preview = window.open();
    if (preview) {
      preview.document.open();
      preview.document.write(html);
      preview.document.close();
    }
  }

  openModal = (type, name) => this.setState({
    modalOpen: true, modalType: type, targetName: name || '',
  });

  closeModal = () => this.setState({
    modalOpen: false, modalType: null, activeName: '', targetName: '',
  });

  render() {
    const em = this.props.store.emailManagement;
    const templates = em.templates || [];

    return (
      <>
        <Card padded={false}>
          <TableToolbar
            title="Templates"
            count={templates.length}
            right={(
              <Button
                variant="primary"
                icon={UploadIcon}
                onClick={() => this.openModal('uploadTemplates')}
              >
                Upload templates
              </Button>
            )}
          />

          {em.loading.getTemplates ? (
            <div className="p-6"><Spinner label="Loading templates…" /></div>
          ) : (
            <Table>
              <thead>
                <tr>
                  <Th>Name</Th>
                  <Th>Created</Th>
                  <Th align="right">Actions</Th>
                </tr>
              </thead>
              <tbody>
                {templates.map((template) => {
                  const active = this.state.activeName === template.name;
                  return (
                    <React.Fragment key={template.name}>
                      <Tr>
                        <Td>
                          <button
                            type="button"
                            onClick={() => this.rowClick(template.name, template)}
                            className="inline-flex items-center gap-2 cursor-pointer text-left"
                            style={{ background: 'transparent', border: 0, padding: 0, color: 'inherit' }}
                          >
                            {active ? <ChevronDownIcon size={14} className="text-mov-ink-mute" /> : <ChevronRightIcon size={14} className="text-mov-ink-mute" />}
                            <b>{template.name}</b>
                          </button>
                        </Td>
                        <Td mute>{moment.utc(template.createdAt, 'ddd, DD MMM YYYY hh:mm:ss').format('MM/DD/YY')}</Td>
                        <Td align="right">
                          <div className="inline-flex items-center gap-1 justify-end">
                            <IconButton variant="ghost" icon={EyeIcon} ariaLabel="Preview" disabled={em.loading.getTemplate} onClick={() => this.preview(template)} />
                            <IconButton variant="ghost" icon={MailIcon} ariaLabel="Test email" onClick={() => this.openModal('sendTestEmail', template.name)} />
                            <IconButton variant="ghost" icon={EditIcon} ariaLabel="Edit" onClick={() => this.rowClick(template.name, template)} />
                            <IconButton variant="ghost" icon={TrashIcon} ariaLabel="Delete" onClick={() => this.openModal('deleteTemplate', template.name)} />
                          </div>
                        </Td>
                      </Tr>
                      {active && (
                        <tr>
                          <td colSpan={3} style={{ padding: 0, borderBottom: '1px solid var(--mov-line)' }}>
                            <div style={{ padding: 18, background: 'var(--mov-paper-2)' }}>
                              {em.loading.getTemplate
                                ? <Spinner label="Loading…" />
                                : <TemplateDropdown template={template} />}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </Table>
          )}
        </Card>

        <Modals
          open={this.state.modalOpen}
          type={this.state.modalType}
          templateName={this.state.targetName}
          onClose={this.closeModal}
        />
      </>
    );
  }
}

export default inject('store')(observer(Templates));
